// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1_mtw","content":"GlobalSearch_content__3vE1R"};